import React from "react";

const NotFound = () => {
    return(
        <div>Oups ! Something went wrong :/</div>
    )
}

export default NotFound;